<template>
  <div class="empty-bag">
    <p class="text">YOUR BAG IS EMPTY</p>
    <div class="button-group">
      <Button
        v-for="item in menu"
        :key="item.url"
        :href="item.url"
        full-width
        theme="outline"
        tag="a"
      >
        {{ item.title }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

const EMPTY_BAG_LINKS = [
  { title: "New In", url: "/collections/new-in" },
  { title: "Dresses", url: "/collections/dresses" },
  { title: "Separates", url: "/collections/separates" },
  { title: "Bestsellers", url: "/collections/best-sellers" },
  { title: "Shop All", url: "/collections/all" },
];

export default {
  name: "EmptyBagState",
  components: {
    Button,
  },
  data() {
    return {
      menu: EMPTY_BAG_LINKS,
    };
  },
};
</script>

<style lang="scss" scoped>
.empty-bag .text {
  text-align: center;
  @include t__utility-body-20;
  font-family: $utility-font-family;
  font-weight: 400;
  letter-spacing: 1px;
  padding: 15px 0;
  margin-bottom: 15px;
}

.button-group {
  padding: 0 40px;

  & > * {
    margin: 0 0 15px;
  }

  :deep(.button) {
    font-family: $utility-font-family;
    font-weight: 400;
    letter-spacing: 1px;
  }
}
</style>
